import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ReactReduxContext } from 'react-redux';
import { setViewedPages } from 'platform/forms-system/src/js/actions';

export const directDepositTitle = 'Direct deposit for disability compensation';

// Changing the answer on review & submit activates a follow-up page with no
// review UI, so the veteran can never "view" it and the chapter shows the
// "There may be errors" banner. Mark that page as viewed instead.
const getFollowUpPageKey = hasNoAccount => {
  if (hasNoAccount === true) return 'otherPaymentOptions';
  if (hasNoAccount === false) return 'paymentInformation';
  return null;
};

export const DirectDepositDescription = ({ formData, formContext }) => {
  const reduxContext = useContext(ReactReduxContext);
  const dispatch = reduxContext?.store?.dispatch;
  const onReviewPage = formContext?.onReviewPage;
  const hasNoAccount = formData?.directDeposit?.hasNoAccount;

  useEffect(() => {
    const pageKey = getFollowUpPageKey(hasNoAccount);
    if (onReviewPage && pageKey && dispatch) {
      dispatch(setViewedPages([pageKey]));
    }
  }, [dispatch, onReviewPage, hasNoAccount]);

  return (
    <>
      <p>
        The Department of Treasury requires that you receive all federal benefit
        payments by direct deposit.
      </p>
      <p>
        If we approve your disability compensation claim, we’ll deposit your
        payments directly into your bank account.
      </p>
    </>
  );
};

DirectDepositDescription.propTypes = {
  formContext: PropTypes.shape({
    onReviewPage: PropTypes.bool,
  }),
  formData: PropTypes.shape({
    directDeposit: PropTypes.shape({
      hasNoAccount: PropTypes.bool,
    }),
  }),
};
